import lottie from "lottie-web";
import isInViewport from "../../../../assets/scripts/extends/components/is-in-viewport";
import { pauseAnimation, resumeAnimation, isAnimationStopped } from "../../../../assets/scripts/extends/cookiesManager";

const lottieContainer = document.querySelectorAll(".lottie-svg");

lottieContainer.forEach((animation, index) => {
  let play = true;
  const url = animation.dataset.url;
  const loop = animation.dataset.loop === "true";

  const animationItem = lottie.loadAnimation({
    container: animation.querySelector(".lottie-svg__svg"),
    renderer: "svg",
    loop,
    autoplay: false,
    path: url,
  });

  if (isAnimationStopped()) {
    console.log('LOTTIE - INIT should be stopped for now');
    animationItem.addEventListener('DOMLoaded', () => {
      const lastFrame = animationItem.totalFrames - 1;
      animationItem.goToAndStop(lastFrame, true);
      animationItem.setLoop(false);
    });
  }

  const runLottie = () => {
    if (isInViewport(animation) && play) {
      play = false;
      setTimeout(function () {
        lottie.play();
      }, 750);
    }
  };

  ["load", "resize", "scroll"].forEach(function (evt) {
    window.addEventListener(evt, runLottie);
  });
});
